var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSadsmiley(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 33 33",
    style: {
      enableBackground: "new 0 0 33 33"
    },
    xmlSpace: "preserve",
    width: 100,
    height: 100,
    className: "svg-color p-md-0 p-3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M16.5,33C7.402,33,0,25.598,0,16.5S7.402,0,16.5,0S33,7.402,33,16.5S25.598,33,16.5,33z M16.5,1C7.953,1,1,7.953,1,16.5 S7.953,32,16.5,32S32,25.047,32,16.5S25.047,1,16.5,1z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.702,
    cy: 11.93,
    r: 2.125
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21.827,
    cy: 11.93,
    r: 2.125
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.326,23.918c-0.09,0-0.18-0.024-0.262-0.074c-0.235-0.146-0.308-0.453-0.163-0.688c1.429-2.314,3.905-3.696,6.623-3.696 c2.679,0,5.136,1.352,6.572,3.615c0.148,0.233,0.079,0.542-0.154,0.689c-0.234,0.147-0.542,0.08-0.69-0.154 c-1.251-1.973-3.393-3.15-5.727-3.15c-2.368,0-4.526,1.204-5.772,3.222C10.658,23.834,10.494,23.918,10.326,23.918z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSadsmiley);
export default __webpack_public_path__ + "static/media/sadsmiley.31aad006.svg";
export { ForwardRef as ReactComponent };